// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e2c60ea0","977":"91d97ba3"}[chunkId] + ".chunk.js";
};